export interface PublishedLocaleBundle {
  version: string;
  locale: 'en' | 'fa';
  entries: Record<string, string>;
}

/** Split flat namespace.key entries into i18next per-namespace bundles. */
export function entriesToNamespaceResources(
  entries: Record<string, string>
): Record<string, Record<string, string>> {
  const byNs: Record<string, Record<string, string>> = {};
  for (const [compoundKey, value] of Object.entries(entries)) {
    const dot = compoundKey.indexOf('.');
    if (dot <= 0) continue;
    const ns = compoundKey.slice(0, dot);
    const key = compoundKey.slice(dot + 1);
    byNs[ns] ??= {};
    byNs[ns][key] = value;
  }
  return byNs;
}
